import CryptoJS from 'crypto-js'
import  appConfig from 'src/appConfig.json'
import utilty from 'src/helpers/utitlity'
import * as webStore from 'src/utils/webStore'

const storage = webStore.namespace('hr_win_')

function transformData(data,isEncrypt){
  switch(typeof data){
    case 'boolean':
    return isEncrypt ? 'isBoolean'+data : data == 'isBooleantrue' ? true : false;
    case 'number':
      return isEncrypt ? ''+data : parseFloat(data);
    case 'object':
    case 'string':
      if(isEncrypt && typeof data == 'object'){
        return JSON.stringify(data)
      } else if(utilty.isJsonObject(data)){
        return JSON.parse(data)
      } else {
        return data
      }
    default: return data
  }
}
const goodalipi = {
  set: (key, data) => {
    if(CryptoJS){
      data = CryptoJS.AES.encrypt(transformData(data,true),appConfig.goodalipiKey).toString()
    }
    storage(key, data);
  },
  get: (key) => {
    let data = storage(key)
    if (CryptoJS && data!==null) {
      data = CryptoJS.AES.decrypt(data.toString(), appConfig.goodalipiKey)
      data = data.toString(CryptoJS.enc.Utf8);
    }
    return transformData(data)
  },
  remove: (name) => {
    storage.remove(name)
  },
  gettoken: (key) => {
    return storage(key)
  }
}

export default goodalipi